import './alert-container.scss'

import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus/src/busTopics'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import Component from 'vue-class-component'

@Component({
    template: require('./alert-container.html'),
})
export class AlertContainer extends ReactiveVue {
    public alertMessage: string = ''
    public alertVariant: string = ''
    public show: boolean = false

    private saveAlertTimeout = null as any
    private readonly SAVE_ALERT_DURATION = 3000

    public mounted() {
        this.subscribeToBus(DISPLAY_ALERT_TOPIC, (message) => {
            if (message.payload) {
                this.showAlert(message.payload)
            }
        })
    }

    private showAlert(alertData: any) {
        clearTimeout(this.saveAlertTimeout)
        this.show = false
        this.alertMessage = alertData.message
        this.alertVariant = alertData.variant
        setTimeout(() => {
            this.show = true
            this.saveAlertTimeout = setTimeout(() => {
                this.show = false
            }, this.SAVE_ALERT_DURATION)
        }, 200)
    }
}
